import token, { tokenToVars } from '../token';
import Alert from './alert';

export { Alert };
export default tokenToVars(Alert, token);
